if($('header#header').length){


    if($('.scroolStrip').length){
            var $strip = $('.scroolStrip');
            var $originalUl = $strip.find('ul').first();
            var $cloneUl = $originalUl.clone();
            $strip.append($cloneUl);
            var totalWidth = $originalUl.width();
            console.log(totalWidth)
            function startMarquee() {
              $strip.animate({ scrollLeft: totalWidth }, 30000, 'linear', function() {
                $strip.scrollLeft(0);
                startMarquee();
              });
            }
            startMarquee();
    }

    $('.responsive-tools').append($('.top-navigation-tools .dropdown').clone())
    $('.responsive-tools').append('<div class="superCart"><i></i><span class="title">Košík</span><span class="price"></span></div>')
    
    $('.header-top').append($('.responsive-tools'))    
    $('#customerLogin input[name="email"]').attr('placeholder', '').before('<label for="email">Uživatelské jméno nebo e-mail<span>*</span></label>')
	$('#customerLogin input[name="password"]').attr('placeholder', '').before('<label for="password">Heslo<span>*</span></label>')
    $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner');    
    $('nav#navigation img').each(function(){
        $(this).attr('src', $(this).attr('data-src'))
    })
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    })
    $(document).on('click', function (event) {
        var clickedElement = $(event.target);
       
        if (!(clickedElement.closest('.login-widget').length || clickedElement.is('a[data-target="login"]'))) {
            $('body').removeClass('login-window-visible user-action-visible');
        }
    });
    $(document).ready(function(){
        cloneCart();
    })
    document.addEventListener('ShoptetCartUpdated', function() {
        setTimeout(function(){
            cloneCart();
        }, 301)
        
    });
    
}
$('.popup-widget.cart-widget').prepend('<div class="cartTop"><p>Nákupní košík</p><span class="close"></span></div>');
$('.popup-widget.cart-widget .cart-widget-button').prepend('<div class="totalprice"><span class="withvat">Celkem včetně DPH: <span class="price"></span></span><span class="withoutVat">celkem bez DPH <span class="price"></span></span></div></div><span class="btn closeCart">Zpět k nakupování</span>')
$('html').on('click', 'header#header .superCart', function(){
    var target = 'cart';
    if (!$('body').hasClass(target + '-window-visible')) {
        var show = (target === 'cart' && !$('a[data-target="cart"]').hasClass('full')) ? false : true;
        shoptet.global.showPopupWindow(target, show);

    }
    else{
        $('body').removeClass(target + '-window-visible')
    }
})
$('html').on('click', '.cartTop, .closeCart', function(){
    $('body').removeClass('cart-window-visible')
})
function cloneCart(){
    $('header#header .superCart i').html($('.navigation-buttons a[data-target="cart"] i').text());
    $('header#header .superCart .price').html($('.navigation-buttons a[data-target="cart"] .cart-price').text());
    $('.cart-widget .totalprice .withvat .price').text(Number(getShoptetDataLayer('cartInfo').getNoBillingShippingPrice.withVat).ShoptetFormatAsCurrency())
    $('.cart-widget .totalprice .withoutVat .price').text(Number(getShoptetDataLayer('cartInfo').getNoBillingShippingPrice.withoutVat).ShoptetFormatAsCurrency())

    
    var currentPrice = getShoptetDataLayer('cartInfo').leftToFreeShipping.priceLeft;
    var fullDashArray = 282.74333882308;
    var percentage = (currentPrice / freeShipping) * 100;
    if (percentage > 100) percentage = 100;
    var progressValue = (percentage / 100) * fullDashArray;
    var remainingValue = fullDashArray - progressValue;
    
    var textShipping = getShoptetDataLayer('cartInfo').leftToFreeShipping.priceLeft < 0
        ? '<p><strong>Získali jste dopravu zdarma</strong> Gratulujeme, máte od nás dopravu ZDARMA!</p>'
        : '<p><strong>Získejte dopravu zdarma</strong> Nakupte ještě za <span class="price">' + getShoptetDataLayer('cartInfo').leftToFreeShipping.formattedPrice + '</span></p>';
    
    var progressBar = '<div class="progressBar">'
        + '<div class="progressCircle"><div class="customBar">'
        + '<svg fill="none" viewBox="0 0 100 100" width="50" height="50">'
        + '<circle cx="50" cy="50" r="45" fill="#fff"></circle>'
        + '<path stroke-linecap="round" stroke-width="9" stroke="#eee" stroke-dasharray="282.74333882308" d="M50 5a45 45 0 0 1 0 90 45 45 0 0 1 0-90"></path>'
        + '<path class="progressPath" stroke-linecap="round" stroke-width="9" stroke="#fe4505" stroke-dasharray="' + progressValue + ',' + remainingValue + '" d="M50 5a45 45 0 0 1 0 90 45 45 0 0 1 0-90"></path>'
        + '</svg></div></div>'
        + '<div class="progressText">' + textShipping + '</div>'
        + '</div>';
    $('.cart-widget .progressBar').remove()
    $('.cart-widget').append(progressBar);
    
    
}